// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-01a40470] {\n  width: 100%;\n  padding: 20px;\n  height: 100%;\n  box-sizing: border-box;\n}\n.content .opt[data-v-01a40470] {\n  display: flex;\n  justify-content: flex-end;\n}\n", ""]);
// Exports
module.exports = exports;
